import { useCallback, useState } from "react";

/** Open/close state for the chat "save as draft" popup; `save` reports whether the draft was stored, then `onSaved` runs. */
export const useChatDraft = (save: () => Promise<boolean>, onSaved?: () => void) => {
  const [isDraftOpen, setIsDraftOpen] = useState(false);

  const openDraft = useCallback(() => setIsDraftOpen(true), []);
  const closeDraft = useCallback(() => setIsDraftOpen(false), []);
  const handleSaveDraft = useCallback(async () => {
    if (await save()) {
      setIsDraftOpen(false);
      onSaved?.();
    }
  }, [save, onSaved]);

  return { isDraftOpen, openDraft, closeDraft, handleSaveDraft };
};
